import React, { useEffect, useState, useRef, useCallback } from 'react';
import { NavigationBar } from './components/navigationBar';
import { TopBar } from './components/topBar.js';
import './App.css';
import { PartnersBlock } from './partner/partnerBlock.js';
import { SelectDep } from './components/selectDep.js';
import { Loading } from './components/loading.js';
import { Turl } from './components/tUrl.js'
import { EmailVerificationFlow } from './components/emailVerificationFlow.js';

import { Home } from './home/home.js';
import { Trade } from './trade/trade.js';
import { License } from './license/license.js';
import { Finance } from './finance/finance.js';
import { WithdrawBEP20 } from './finance/withdrawBEP20.js';

import { addLocale, useLocale } from 'ttag';

import en from './i18n/en.po.json';
import uk from './i18n/uk.po.json';
import ru from './i18n/ru.po.json';
import { Deposit } from './trade/deposit.js';
import { Withdraw } from './trade/withdraw.js';
import { BuyLic } from './license/buyLic.js';
import { BuyLicPoints } from './partner/buyLicPoints.js';


addLocale('uk', uk);
addLocale('en', en);
addLocale('ru', ru);



const tg = window.Telegram && window.Telegram.WebApp ? window.Telegram.WebApp : null;

function getLoc() {

  let lng = localStorage.getItem("lng") || 'en'
  return lng
}

function App() {
  const [locale, setlocalee] = useState(getLoc());
  useLocale(locale);
  const [index, setIndex] = useState(0);
  const [isMiniApp, setIsMiniApp] = useState(false);
  const [showError, setShowError] = useState(false);
  const [recData, setRecData] = useState();
  const [isDoDep, setisDoDep] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const hasFetchedData = useRef(false);

  const upd = () => {
    setRecData(null)
    sendAuthData()
  }


  const sendAuthData = async () => {
    hasFetchedData.current = true;
    try {
      const _userData = tg ? tg.initData : null;
      let userData = { initData: _userData }

      //console.log(userData);

      if (userData) {
        const response = await fetch(Turl + '/st/auth', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(userData)
        });

        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        const rd1 = await response.json();
        //console.log(rd1);
        //setLocal(getLocale())
        if (rd1.error === true) {
          setErrorMessage(rd1.message)
        }
        else {
          setRecData(rd1)
        }
      } else {
        console.warn("Telegram user data not available.");
      }

    } catch (error) {
      console.error('Authentication error:', error);
    }
  };

  useEffect(() => {

    //if (tg.initData) {
    if (tg) {
      setIsMiniApp(true);
    } else {
      setShowError(true);
    }

    if (tg && !recData && !hasFetchedData.current) {
      /*     try {
            const userData = window.Telegram.WebApp.initDataUnsafe?.user;
            if (userData) {
              mixpanel.identify(userData.id);
            }
          } catch (error) {
    
          }
     */
      sendAuthData();
    }
  }, [tg, recData]); // Зависимости useEffect

  if (showError) {
    return (
      <div className="error-container">
        <p>This application is designed to be used inside Telegram Mini Apps.</p>
      </div>
    );
  }

  const closeModal = () => {
    setErrorMessage('');
    upd();
  };

  if (errorMessage)
    return <div className="modal">
      <div className="modal-content">
        <span className="close-button" onClick={closeModal}>&times;</span>
        <p className="error-message">{errorMessage}</p>
      </div>
    </div>

  if (!recData) {
    return <Loading />;
  }
  hasFetchedData.current = false;



  const l1 = (
    <Home handlesetIndex={setIndex} recData={recData} />
  );

  const l2 = (
    <Trade handlesetIndex={setIndex} recData={recData} />
  );

  const l21 = (
    <Deposit handlesetIndex={setIndex} recData={recData} />
  );

  const l22 = (
    <Withdraw handlesetIndex={setIndex} recData={recData} />
  );

  const l3 = (
    <License handlesetIndex={setIndex} recData={recData} />
  );
  const l31 = (
    <BuyLic handlesetIndex={setIndex} recData={recData} />
  );

  const l4 = (
    <Finance handlesetIndex={setIndex} recData={recData} />
  );

  const l41 = (
    recData.user.email ?
      <SelectDep handlesetIndex={setIndex} setIsAuthorized={upd} wallet={recData.wallet} depWallet={recData.depWallet} isDoDep={isDoDep} setisDoDep={setisDoDep} setErrorMessage={setErrorMessage} />
      :
      <EmailVerificationFlow handlesetIndex={setIndex} setIsAuthorized={upd} wallet={recData.wallet} depWallet={recData.depWallet} isDoDep={isDoDep} setisDoDep={setisDoDep} setErrorMessage={setErrorMessage} />
  );

  const l42 = (
    <WithdrawBEP20 handlesetIndex={setIndex} recData={recData} />
  );


  const l5 = (
    <PartnersBlock handlesetIndex={setIndex} recData={recData} />
  );
  const l51 = (
    <BuyLicPoints handlesetIndex={setIndex} recData={recData} />
  );
  return (
    <div className="dashboard-container">
      <TopBar email={recData.email} handlesetIndex={setIndex} index={index} setIsAuthorized={upd} setlocale={setlocalee} />
      {index === 0 && l1}
      {index === 1 && l2}
      {index === 2 && l3}
      {index === 3 && l4}
      {index === 4 && l5}
      {index === 51 && l51}
      {index === 21 && l21}
      {index === 22 && l22}
      {index === 31 && l31}
      {index === 41 && l41}
      {index === 42 && l42}

      <NavigationBar handlesetIndex={setIndex} index={index} />
      {errorMessage && (
        <div className="modal">
          <div className="modal-content">
            <span className="close-button" onClick={closeModal}>&times;</span>
            <p className="error-message">{errorMessage}</p>
          </div>
        </div>
      )}
    </div>
  );
}

export default App;